import { Injectable } from "@angular/core";
import * as io from "socket.io-client";
import { environment } from "./../../environments/environment";

@Injectable()
export class SocketioService {
    public socket = null;
    constructor() {
        if (!this.socket) {
            this.socket = io.connect(
                environment.SOCKET_URL,
                {
                    query: {
                        token: localStorage.getItem("gp_token"),
                        host: "GU"
                    }
                }
            );
        }
    }
}
    



// WEBPACK FOOTER //
// ./src/common/services/socketio.service.ts